/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Payment, PaymentFromJSON, PaymentToJSON } from './'

/**
 *
 * @export
 * @interface PaymentResponse
 */
export interface PaymentResponse {
  /**
   *
   * @type Payment
   * @memberof PaymentResponse
   */
  payment: Payment
  /**
   * Will be provided if the payment method is CC (credit card) and a billing address was provided. Used on the frontend to present to the Authorize.net form to collect payment. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page
   * @type string
   * @memberof PaymentResponse
   */
  ccFormToken?: string
}

export function PaymentResponseFromJSON(json: any): PaymentResponse {
  return PaymentResponseFromJSONTyped(json, false)
}

export function PaymentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaymentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    payment: PaymentFromJSON(json['payment']),
    ccFormToken: !exists(json, 'ccFormToken') ? undefined : json['ccFormToken'],
  }
}

export function PaymentResponseToJSON(value?: PaymentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    payment: PaymentToJSON(value.payment),
    ccFormToken: value.ccFormToken,
  }
}
